import { Workbox } from 'workbox-window';


export default function registerServiceWorker() {
  // Check if the serviceWorker Object exists in the navigator object ( means if browser supports SW )
  if ('serviceWorker' in navigator) {
    const wb = new Workbox('sw.js');

    wb.addEventListener('installed', event => {
      /**
       * We have the condition — event.isUpdate because we don’t want to show
       * this message on the very first service worker installation,
       * only on the updated
       */
      // TODO make communication between apps < - > SW to notify about new version
      if (event.isUpdate) {
        // alert('New version is available. Please refresh the page');
        console.info('application new version available');
        // window.location.reload();
      }
    });
    wb.register();
  }
}

export function registerPerformanceWorker(allowedLinks: Record<string, string>) {
  if (typeof Worker !== 'undefined') {
    try {
      const worker = new Worker('performance-metrics.worker.js');
      const allowedMetrics = [
        'LCP',
        'FCP',
        'CLS',
        'TTFB',
        'INP',
      ];
      worker.postMessage({
        type: 'INIT',
        allowedLinks,
        platformApiHost: (window as any).PlatformSetup?.platformApiUrl || `https://platform.${window.location.host}`,
        allowedMetrics,
      });

      worker.onmessage = (event) => {
        if (event.data && event.data.type === 'BATCH_METRICS_SENT') {
          window.__perfMetrics = {};
        }
      };

      (window as any).performanceWorker = {
        worker: worker,
        allowedMetrics,
        setCountry: async (country) => {
          return new Promise<void>((resolve) => {
            (window as any).performanceWorker.worker.postMessage({ type: 'SET_COUNTRY', country: country });
            resolve();
          });
        },
      };
      if ((window as any).__APP_PRELOAD__.getCustomerIpData) {
        (window as any).__APP_PRELOAD__.getCustomerIpData.then((res) => {
          (window as any).performanceWorker.setCountry(res.country);
        });
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Failed to start performance metrics worker', e);
    }
  }
}
